import useClubOwnerTypeMultiselect from './UseClubOwnerTypeMultiselect';

import MultiSelect from '@usas/ui-web/components/multiSelect/MultiSelect';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubOwnerTypeMultiselect = ({ label, name, value, error, message, onChange }) => {
  const { clubOwnerTypeState, options } = useClubOwnerTypeMultiselect();

  return clubOwnerTypeState.message
    ? <span className={global.LoadingMsg}>{clubOwnerTypeState.message}</span>
    : (
      <MultiSelect
        label={label}
        name={name}
        value={value}
        options={options}
        error={error}
        message={message}
        isLoading={clubOwnerTypeState.isLoading}
        onChange={onChange} />
    );
};

export default ClubOwnerTypeMultiselect;
